import { z } from 'zod';

import { baseToolDefinitionSchema } from './mcpIntegration';

/**
 * Agent skill contracts (D4 — built on the shared tool-definition base).
 * A skill is markdown content loaded on demand via the `load_skill` tool.
 */
const skillBaseSchema = baseToolDefinitionSchema.extend({
  name: z
    .string()
    .min(1)
    .max(60)
    .regex(
      /^[a-z][\d_a-z]*$/,
      'Lowercase letters, digits and underscores; must start with a letter',
    ),
  description: z.string().min(10).max(500),
  content: z.string().min(1).max(20_000),
});

export const createSkillSchema = skillBaseSchema;

export const updateSkillSchema = skillBaseSchema
  .partial()
  .extend({ id: z.string().uuid() });

export const skillOutputSchema = skillBaseSchema.extend({
  id: z.string().uuid(),
});

export type CreateSkillDTO = z.infer<typeof createSkillSchema>;
export type UpdateSkillDTO = z.infer<typeof updateSkillSchema>;
export type SkillOutput = z.infer<typeof skillOutputSchema>;
